import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import { FormatAsCents } from "../../../utils/Helpers/Format";

import Range from "../../shared/InputElements/Range";
import {useIntl} from 'react-intl';


const SlideGasolinePrice = ({
  id = "gasoline-price-range",
  ...rest
}) => {
  const intl = useIntl()
  const label = intl.formatMessage ? intl.formatMessage({ id: "gasolinePriceLabel", defaultMessage:  "Gasoline Price ($/gal)"}) : "Gasoline Price ($/gal)"

  const userPrefs = useContext(UserPrefsContext);
  const description = (val) => {
    return `${FormatAsCents(val / 100)}${
      intl.formatMessage
        ? intl.formatMessage({ id: 'ev.perGallon', defaultMessage: '/gallon' })
        : '/gallon'
    }`;
  };

  return (
    <Range
      id={id}
      value={userPrefs.get("gasolinePriceInCentsPerGal")}
      label={label}
      rangeMin={200}
      rangeMax={1000}
      rangeStep={10}
      description={description}
      handler={e =>
        userPrefs.set({ gasolinePriceInCentsPerGal: e.target.value })
      }
      {...rest}
    />
  );
};

export default SlideGasolinePrice;

SlideGasolinePrice.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.func,
  tooltip: PropTypes.string
};
